import { cloneDeep } from "lodash"
const dataTemplate = {
  '患者手术综合评估建议': [
    {
      '评估结论': [
        {
          label: '评估结论',
          name: 'diagnose',
          type: 'textArea',
          inputVal: ''
        }
      ]
    }
  ],
  '上传3D文件': [
    {
      '头骨文件': [
        {
          loading: false,
          type: 'onlyFile',
          name: 'harnpan',
          files: []
        }
      ],
      '瘤体文件':[
        {
          type: 'onlyFile',
          tip: '瘤体文件',
          loading: false,
          files: [],
          name: 'tumour'
        }
      ],
      '载流动脉文件': [
        {
          type: 'onlyFile',
          tip: '载流动脉文件',
          loading: false,
          files: [],
          name: 'vascellum'
        }
      ]
    }
  ],
  '形态学指标分析': [
    {
      '动脉瘤形态': [
        {
          name: 'aneurysm_morphology',
          type: 'onlyImage',
          imageSize: '7.6x7.6cm/898x898像素',
          iamgeNum: 4,
          imageList: [
            {
              name: 'aneurysm_morphology_1',
              url: ''
            },
            {
              name: 'aneurysm_morphology_2',
              url: ''
            },
            {
              name: 'aneurysm_morphology_3',
              url: ''
            },
            {
              name: 'aneurysm_morphology_4',
              url: ''
            }
          ]
        }
      ],
      '颅内动脉瘤大小(长径)Hmax':[
        {
          label: '颅内动脉瘤大小(长径)Hmax',
          type: 'onlyNum',
          name: 'Hmax',
          inputVal: '',
          valUnit: 'mm'
        }
      ],
      '颅内动脉瘤体宽度(宽径)SW': [
        {
          name: 'SW',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm'
        }
      ],
      '颅内动脉瘤体横径ST':[
        {
          name: 'ST',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm'
        },
      ],
      '颅内动脉瘤高度H': [
        {
          name: 'H',
          type: 'onlyNum',  
          inputVal: '',
          valUnit: 'mm'
        }
      ],
      '载瘤动脉直径PAD':[
        {
          name: 'PAD',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm'
        }
      ],
      '颅内动脉瘤颈直径ND': [
        {
          name: 'ND',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm'
        }
      ],
      '动脉瘤入射角度AIF': [
        {
          name: 'AIF',
          type: 'onlyNum',
          inputVal: '',
          valUnit: '°'
        }
      ],
      '颅内动脉瘤体积V': [
        {
          name: 'V',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm³'
        }
      ],
      '颅内动脉瘤表面积SA': [
        {
          name: 'SA',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'mm²'
        }
      ],
      '动脉瘤尺寸比SR': [
        {
          name: 'SR',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '动脉瘤纵横比AR': [
        {
          name: 'AR',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '动脉瘤长宽比WHR': [
        {
          name: 'WHR',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '瘤体宽径与瘤颈比BNR': [
        {
          name: 'BNR',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '动脉瘤非球形指数NSI': [
        {
          name: 'NSI',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '壁面剪应力均值WSSA': [
        {
          name: 'WSSA',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '归一化壁面剪应力均值NWSSA': [
        {
          name: 'NWSSA',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '壁面剪应力最大值MWSS': [
        {
          name: 'MWSS',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '归一化壁面剪应力最大值NWSSM': [
        {
          name: 'NWSSM',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '压力均值PA': [
        {
          name: 'PA',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'pa'
        }
      ],
      '归一化压力均值NPA': [
        {
          name: 'NPA',
          type: 'onlyNum',
          inputVal: '',
          valUnit: 'pa'
        }
      ],
      '壁面剪应力梯度WSSG': [
        {
          name: 'WSSG',
          type: 'onlyNum',
          inputVal: ''
        },
      ],
      '低壁面切应力面积比LSAR': [
        {
          name: 'LSAR',
          type: 'onlyNum',
          inputVal: ''
        },
      ],
      '切应力振荡指数OSI': [
        {
          name: 'OSI',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '相对停留时间RRT': [
        {
          name: 'RRT',
          type: 'onlyNum',
          inputVal: ''
        }
      ]
    }
  ]
}

let labelMap = {
  'aneurysm_morphology': '动脉瘤形态',
  'RRT': '相对停留时间RRT',
  'OSI': '切应力振荡指数OSI',
  'LSAR': '低壁面切应力面积比LSAR',
  'WSSG': '壁面剪应力梯度WSSG',
  'NPA': '归一化压力均值NPA',
  'PA': '压力均值PA',
  'NWSSM': '归一化壁面剪应力最大值NWSSM',
  'MWSS': '壁面剪应力最大值MWSS',
  'NWSSA': '归一化壁面剪应力均值NWSSA',
  'WSSA':'壁面剪应力均值WSSA',
  'NSI':'动脉瘤非球形指数NSI',
  'BNR': '瘤体宽径与瘤颈比BNR',
  'WHR': '动脉瘤长宽比WHR',
  'AR': '动脉瘤纵横比AR',
  'SR': '动脉瘤尺寸比SR',
  'SA':'颅内动脉瘤表面积SA',
  'V': '颅内动脉瘤体积V',
  'AIF':'动脉瘤入射角度AIF',
  'ND': '颅内动脉瘤颈直径ND',
  'PAD': '载瘤动脉直径PAD',
  'H': '颅内动脉瘤高度H',
  'ST':'颅内动脉瘤体横径ST',
  'SW': '颅内动脉瘤体宽度(宽径)SW',
  'Hmax':'颅内动脉瘤大小(长径)Hmax'
}

function createParams(reportData) {
  let params = {
    obj: {},
    diagnose: '',
    materials: []
  }
  params.diagnose = reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal']
  // 形态学指标
  for(let i = 0; i < reportData['形态学指标分析'].length; i++) {
    let tumour = reportData['形态学指标分析'][i]
    let obj = {
      detail: {},
      aneurysm_morphology: []
    }
    for (let k in tumour) {
      let paramItem = tumour[k][0]
      if (paramItem.name === 'aneurysm_morphology') {
        for(let i = 0; i <paramItem.imageList.length; i++) {
          obj.aneurysm_morphology.push(paramItem.imageList[i]['url'])
        }
      } else {
        obj['detail'][paramItem.name] =  {
          value: paramItem.inputVal
        }
        if (paramItem.valUnit) obj['detail'][paramItem.name]['unit'] = paramItem.valUnit
        if (paramItem.imageList) obj['detail'][paramItem.name]['pic'] = [paramItem.imageList[0]['url']]
      }
    }
    params.materials.push(obj)
  }
  // obj文件
  let objFile = reportData['上传3D文件'][0]
  for (let k in objFile) {
    let cateFile = objFile[k][0]
    params['obj'][cateFile.name] = []
    for (let i = 0; i < cateFile.files.length; i++) {
      let file = cateFile.files[i]
      params['obj'][cateFile.name].push(file.url)
    }
  }
  return params
}

function parseJsonObj(jsonObj) {
  let reportData = cloneDeep(dataTemplate)
  for (let k in jsonObj) {
    let item = jsonObj[k]
    if (k === 'diagnose') {
      reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal'] = item
    }
    // obj文件 
    if (k === 'obj') {
      for (let j in item) {
        let list = item[j]
        for (let i = 0; i < list.length; i++) {
          if (j === 'harnpan') {
            reportData['上传3D文件'][0]['头骨文件'][0]['files'].push({url:list[i], name:`头骨文件${i+1}`})
          } else if (j === 'tumour') {
            reportData['上传3D文件'][0]['瘤体文件'][0]['files'].push({url:list[i], name:`瘤体文件${i+1}`})
          } else if (j === 'vascellum') {
            reportData['上传3D文件'][0]['载流动脉文件'][0]['files'].push({url:list[i], name:`载流动脉文件${i+1}`})
          }
        }
      }
    } 
    if (k === 'materials') {
      for (let i = 0; i < item.length; i++) {
        if (i !== 0) {
          let cloneData = cloneDeep(dataTemplate['形态学指标分析'][0])
          reportData['形态学指标分析'].push(cloneData)
        }
        let valItem = item[i]
        let targetItem = reportData['形态学指标分析'][i]
        let detailData = valItem.detail
        let amImages = valItem.aneurysm_morphology
        for (let i = 0; i <amImages.length; i++) {
          targetItem['动脉瘤形态'][0]['imageList'][i]['url'] = amImages[i]
        }
        for(let dKey in detailData) {
          let detailItem = detailData[dKey]
          if (detailItem.unit) {
            targetItem[labelMap[dKey]][0]['valUnit'] = detailItem.unit
          }
          if (detailItem.value) {
            targetItem[labelMap[dKey]][0]['inputVal'] = detailItem.value
          }
        } 
      }
    }
  }
  return reportData
}



export default {dataTemplate, createParams, parseJsonObj, reportType: 'ANEURYSM'}